// RewardClaimPage — Choose which stock to receive as reward
// Layout (matches attached photo):
//   - "You'll receive $4 in AAPL" sheet
//   - Apple icon + confirmation copy
//   - "Confirm reward" black button

import { useNavigate } from 'react-router-dom';
import { STOCKS, REWARD_OFFER } from '../../data/stocks';

export function RewardClaimPage() {
  const nav = useNavigate();
  // Default to Apple for now (could be picked from query param)
  const stock = STOCKS[0];
  return (
    <div className="min-h-screen bg-white">
      {/* Top nav */}
      <div className="sticky top-0 z-10 flex h-11 items-center justify-between border-b border-tf-border bg-white/85 px-2 backdrop-blur-xl">
        <button onClick={() => nav('/portal/rewards')} data-testid="back" className="flex h-9 w-9 items-center justify-center text-tf-blue">
          <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2.4"><path d="M15 5l-7 7 7 7" strokeLinecap="round" strokeLinejoin="round" /></svg>
        </button>
        <div className="absolute left-1/2 -translate-x-1/2 text-[15px] font-semibold">Claim reward</div>
        <div className="w-9" />
      </div>

      <div className="px-4 pt-12">
        <div className="flex justify-center">
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-white border border-tf-border" style={{ boxShadow: '0 4px 24px rgba(0,0,0,0.10)' }}>
            <img src={stock.icon} alt={stock.name} className="h-14 w-14 rounded-full" />
          </div>
        </div>
        <h1 className="mt-6 text-center text-[22px] font-bold tracking-tight text-tf-text-1">You'll receive ${REWARD_OFFER.stockValue.toFixed(0)} in {stock.symbol}</h1>
        <p className="mt-2 text-center text-[14px] text-tf-text-3">
          Reward stock will be added to your<br />portfolio instantly.
        </p>

        <button
          onClick={() => nav('/portal/rewards/unlocked', { state: { stock } })}
          data-testid="confirm-reward"
          className="mt-8 flex h-[52px] w-full items-center justify-center rounded-full bg-tf-text-1 text-[16px] font-semibold text-white active:scale-[0.99]"
        >
          Confirm reward
        </button>

        <button
          onClick={() => nav('/portal/choose-stock')}
          className="mt-3 flex h-[44px] w-full items-center justify-center text-[15px] font-semibold text-tf-blue active:opacity-40"
        >
          Choose a different stock
        </button>
      </div>
    </div>
  );
}
